import { uuidRegex } from '@flowx/designer/shared/entities/utils'

export { pluralize as countOf } from '@flowx/designer/shared/pluralize'

/** The beat between tool calls. One constant because two surfaces say it in the same turn — the
 * hold's caption and the trace row — and they were spelled differently. */
export const THINKING = 'Thinking…'

/** The designer's own uuid pattern, anchored — the same composition `corrective-actions-models`
 * does with it. A uuid reads as a slug to `unslug`'s test, and "A1b2c3d4 e5f6 4789 …" is worse
 * than the raw id, so it is checked for first; callers that would rather show nothing than 36
 * characters of hex ask here too. */
const UUID = new RegExp(`^${uuidRegex}$`, 'i')

export function isUuid(value: string): boolean {
  return UUID.test(value)
}

/** `add-a-fraud-check` → `Add a fraud check`. Leaves anything that is not a slug alone. Here
 * rather than beside either display mapper: both read ids the harness minted from prose, and the
 * brief's normaliser had to import the plan's to say so. */
export function unslug(id: string): string {
  if (!id || isUuid(id) || !/^[a-z0-9]+(?:[-_][a-z0-9]+)+$/i.test(id)) {
    return id
  }

  const words = id.replace(/[-_]+/g, ' ')

  return words.charAt(0).toUpperCase() + words.slice(1)
}
